export default __webpack_public_path__ + "static/media/thethirdtemple.7dabb848.jpg";